<template>
  <v-container
    class="sell-offers-view-container"
    fluid
  >
    <h1>SellOffers</h1>
    <SellOffersTable
      :selloffers="selloffers"
      :selloffers-pagination="pagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { setQuery } from '@/helpers';
import { SellOffersTable } from '@/components/trades';

export default {
  name: 'SellOffers',
  components: {
    SellOffersTable,
  },
  computed: {
    ...mapState({
      loading: state => state.sellOffersStore.loading,
      selloffers: state => state.sellOffersStore.selloffers,
      pagination: state => state.sellOffersStore.pagination,
    }),
  },
  async mounted() {
    const { query } = this.$route;
    const params = { ...this.pagination, ...query };

    setQuery(
      {
        ...params,
      },
      this.$route,
      this.$router,
    );
  },
};
</script>
<style scoped>
.sell-offers-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/SellOffers.vue